import { useState,useEffect } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Nav, Navbar, Button, Dropdown, DropdownButton } from 'react-bootstrap';

import { loginRequest } from '../authConfig';
import { AccountPicker } from './AccountPicker';
import { clearStorage } from '../utils/storageUtils';

export const NavigationBar = () => {
    const [showProfilePicker, setShowProfilePicker] = useState(false);
    const { instance, accounts, inProgress } = useMsal();

    let activeAccount;

    useEffect(() => {
        // Handle the redirect promise on component mount
        instance.handleRedirectPromise()
            .then(authResult => {
                // Authentication successful
                console.log("Authentication successful", authResult);
            })
            .catch(err => {
                // Handle errors
                console.error("Redirect error", err);
            });

        // Set the active account
        if (accounts.length > 0) {
            instance.setActiveAccount(accounts[0]);
        }
    }, [instance, accounts]);

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    const handleLoginRedirect = () => {
        if (inProgress === "none") {
            instance.loginRedirect(loginRequest)
                .catch((error) => console.log("Login error", error));
        }
    };

    const handleLogoutRedirect = () => {
        let account = instance.getActiveAccount();
        clearStorage(account);

        instance.logoutRedirect({
            account: instance.getActiveAccount(),
        });
    };

    const handleSwitchAccount = () => {
        setShowProfilePicker(!showProfilePicker);
    };

    /**
     * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
     * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
     * only render their children if a user is authenticated or unauthenticated, respectively.
     */
    return (
        <>
            <Navbar style={{ backgroundColor: '#292268' }} variant="dark" className="navbarStyle">
                <a className="navbar-brand" href="/">
                    cloud37 - Timesheet Utils
                </a>
                <AuthenticatedTemplate>
                    <Nav.Link className="navbarButton" href="/utils">
                        Utils
                    </Nav.Link>
                    <div className="collapse navbar-collapse justify-content-end">
                    <Button 
                            variant="warning" 
                            className="ml-auto my-custom-button-class" 
                            onClick={handleLogoutRedirect}
                            title="Logout">
                            Logout
                        </Button>
                    </div>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <div className="collapse navbar-collapse justify-content-end">
                        <Button 
                            variant="warning" 
                            className="ml-auto my-custom-button-class" 
                            onClick={handleLoginRedirect}
                            title="Sign In">
                            Sign In
                        </Button>
                    </div>
                </UnauthenticatedTemplate>
            </Navbar>
            <AccountPicker show={showProfilePicker} handleSwitchAccount={handleSwitchAccount} />
        </>
    );
};
